module.exports = __webpack_public_path__ + "img/brain.0c1250a8.png";